import axios from "axios";
import API_URL from "../redux2";
import { apiClient } from "../redux2/apiClient";

const getBookingReport = async (token, query) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(API_URL + "booking/report", {
      ...config,
      params: query,
      query: query,
    });

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getSuperBillingReport = async (query) => {
  try {
    const res = await apiClient.get(API_URL + "billing/report", {
      params: query,
      query: query,
    });

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

const getTransactionReport = async (query) => {
  try {
    const res = await apiClient.get(API_URL + "transaction/report", {
      params: query,
      query: query,
    });

    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export { getBookingReport, getSuperBillingReport, getTransactionReport };
